import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OrderCardDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/order-card-dto";

@Component({
  templateUrl: "./card-order-dialog.component.html",
  styleUrls: ["./card-order-dialog.component.scss"],
})
export class CardOrderDialogComponent {
  constructor(public dialogRef: MatDialogRef<CardOrderDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: OrderCardDTO) {}

  getProtocolNumber(): string {
    return this.data.getProtocol().getNumber();
  }

  getCardNumber(): string {
    return this.data.getCard().getCardNumber();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
